import ApiInfo from './ApiInfo.js';

class QuxsApiInfo extends ApiInfo {
    constructor ({ path, type = 'get', timeout = 5000, headers, project = 'quxingshan', author = '逄纯纯' }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        });
    }
}

export default {
    project: {
        list: new QuxsApiInfo({
            path: '/index'
        }),
        set: new QuxsApiInfo({
            path: '/change'
        }),
        delete: new QuxsApiInfo({
            path: '/del'
        }),
        modify: new QuxsApiInfo({
            path: '/setData'
        })
    },
    org: {
        list: new QuxsApiInfo({
            path: '/orgIndex'
        }),
        set: new QuxsApiInfo({
            path: '/orgChange'
        }),
        delete: new QuxsApiInfo({
            path: '/orgDel'
        })
    },
    upload: {
        ossauth: new QuxsApiInfo({
            path: '/ossauth'
        })
    }
};
